import { render } from "./WorkflowDetail.vue?vue&type=template&id=5e2a370c&scoped=true"
import script from "./WorkflowDetail.vue?vue&type=script&lang=js"
export * from "./WorkflowDetail.vue?vue&type=script&lang=js"

import "./WorkflowDetail.vue?vue&type=style&index=0&id=5e2a370c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2a370c"]])

export default __exports__